import React, { useEffect, useState } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import styled from 'styled-components';
import { STATIC_PATH } from '../../config';

const Header = styled.h1`
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
`;
const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
`;
const WideModal = styled(Modal)`
  width: 95%;
  max-width: 1174px;
  margin: 0 auto;
  @media screen and (max-width: 1138px) {
    width: 100%;
  }
`;
const LinkButton = styled.button`
  border: none;
  text-decoration: underline;
  background: transparent;
  margin-left: 2rem;
`;
const CenteredParagraph = styled.p`
  text-align: center;
`;
const FlexContainer = styled.div`
  display: flex;
  height: 470px;
  @media screen and (max-width: 1054px) {
    height: auto;
    flex-direction: column;
  }
`;
const ModalImage = styled.img`
  transform: translate(-1px, -1px);
  @media screen and (max-width: 1054px) {
    display: none;
  }
`;
const StyledModalBody = styled(ModalBody)`
  padding: 40px 80px !important;
  @media screen and (max-width: 768px) {
    padding 20px !important;
  }
`;

const PayoutChangesModal = () => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const savedTime = localStorage.getItem('bank_cards_modal_show_at');
    const isTimeToShow = !savedTime || (savedTime && Date.now() > Number(savedTime));
    const hideModal = localStorage.getItem('bank_cards_modal_hidden');
    !hideModal && isTimeToShow && setOpen(true);
  }, []);

  return (
    <WideModal isOpen={open} centered>
      <FlexContainer>
        <div>
          <ModalImage src={`${STATIC_PATH}/img/modals/cards-modal-img.png`} />
        </div>
        <StyledModalBody>
          <div>
            <Header>Уважаемый партнер!</Header>
            <p>
              Обращаем Ваше внимание, что с 4 февраля 2021 года будут внесены изменения для вывода
              средств на банковские карты, эмитированные банками РФ.
            </p>
            <p>
              <strong>Вам необходимо заполнить два новых поля в разделе "Платежные данные"</strong>
            </p>
            <p>
              1. "Имя" (Латиницей. Как указано на карте. Например: Ivan)
              <br />
              2. "Фамилия" (Латиницей. Как указано на карте. Например: Ivanov)
            </p>
            <p>
              До 04.02.2021 эти поля являются опциональными, после их заполнение станет
              обязательным.
            </p>
            <CenteredParagraph>
              Пожалуйста, учитывайте это и внесите изменения прямо сейчас.
            </CenteredParagraph>
          </div>
          <ButtonsWrapper>
            <button
              className="btn btn-primary"
              onClick={() => {
                const date = new Date();
                date.setDate(date.getDate() + 1);
                localStorage.setItem('bank_cards_modal_show_at', date.getTime());
                setOpen(false);
              }}
            >
              Понятно
            </button>
            <LinkButton
              onClick={() => {
                localStorage.setItem('bank_cards_modal_hidden', true);
                setOpen(false);
              }}
            >
              Уже добавил
            </LinkButton>
          </ButtonsWrapper>
        </StyledModalBody>
      </FlexContainer>
    </WideModal>
  );
};

export default PayoutChangesModal;
